import { toUrlRid } from '../utils/tenantPath';

// Tenancy uses the real role, even during a read-only preview.
export function allowedRestaurants(realRole, user, restaurants) {
  const list = realRole === 'admin' ? restaurants : user?.assigned_restaurants;
  return (Array.isArray(list) ? list : []).filter(r => toUrlRid(r.id) != null);
}

export function resolveLegacyTenant({ realRole, user, restaurants, queryRid, lookupRid, tabHint, lastHint }) {
  const allowed = allowedRestaurants(realRole, user, restaurants);
  const candidates = [queryRid, lookupRid, tabHint, lastHint, user?.restaurant_id, allowed[0]?.id];
  const match = candidates.find(id => allowed.some(r => String(r.id) === String(id)));
  return match == null ? null : String(match);
}

// Only exact, supported by-id legacy routes need a server lookup.
export function legacyLookupTarget(pathname) {
  const match = pathname.match(/^\/(document|supplier|dishes)\/([1-9]\d*)\/?$/);
  if (!match || !Number.isSafeInteger(Number(match[2]))) return null;
  return { type: match[1] === 'dishes' ? 'dish' : match[1], id: match[2] };
}
